export default "<get-started token=\"$ctrl.encryptedToken\"></get-started>";